import memoize from "lodash.memoize";
import { format } from "date-fns";

export const formatMoney = n =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    n
  );

export const expenseCategories = memoize(expenses => {
  return [...new Set(Object.values(expenses).map(({ category }) => category))];
});

export const total = memoize(expenses => {
  if (!expenses) return 0;
  return Object.values(expenses).reduce(
    (total, expense) => total + expense.amount,
    0
  );
});

export const expensesByCategory = memoize(expenses => {
  const byCategory = {};
  Object.entries(expenses).forEach(([id, expense]) => {
    const key = expense.category;
    byCategory[key] || (byCategory[key] = {});
    byCategory[key][id] = expense;
  });
  // console.log(Object.keys(byCategory));
  return byCategory;
});

export const expensesByMonth = memoize(expenses => {
  const byMonth = {};
  Object.entries(expenses).forEach(([id, expense]) => {
    const key = format(expense.date, "YYYY-MM");
    byMonth[key] || (byMonth[key] = {});
    byMonth[key][id] = expense;
  });
  return byMonth;
});

export const expensesByMonthAndCategory = memoize(expenses => {
  const byMonthAndCategory = {};
  const byMonth = expensesByMonth(expenses);

  Object.entries(byMonth).forEach(([month, monthExpenses]) => {
    byMonthAndCategory[month] = expensesByCategory(monthExpenses);
    // const key = format(expense.date, "YYYY-MM");
    // byMonth[key] || (byMonth[key] = {});
    // byMonth[key][id] = expense;
  });
  return byMonthAndCategory;
});

export const expensesByCategoryAndMonth = memoize(expenses => {
  const byCategoryAndMonth = {};
  const byCategory = expensesByCategory(expenses);

  Object.entries(byCategory).forEach(([category, categoryExpenses]) => {
    byCategoryAndMonth[category] = expensesByMonth(categoryExpenses);
    // const key = format(expense.date, "YYYY-MM");
    // byMonth[key] || (byMonth[key] = {});
    // byMonth[key][id] = expense;
  });
  return byCategoryAndMonth;
});
